import {eventBannerClick} from "api";

export default function($app) {
	const self = this;
	let __number = 0;
	let __timer;
	const __container = $('#bannerContainer');
	const banners = $app.event().banner();

	self.isEnabled = ko.computed(() => $app.event().banner().length > 0);

	const Banner = function(banner) {
		if(!banner) return;

		__container.html('');
		$('<div>')
			.css('backgroundImage', `url(${banner.url()})`)
			.on('click', () => {
				eventBannerClick(banner.id());

				if(banner.link()) {
					window.open(banner.link());
				}
			})
			.appendTo(__container)
		;
	};

	const setBanner = () => {
		const banner = banners[__number];
		new Banner(banner);
		clearTimeout(__timer);
		__timer = setTimeout(() => self.next(), banner.timeout() * 1000);
	};

	this.next = () => {
		if(!banners[++__number]) {
			__number = 0;
		}
		setBanner();
		return this;
	};

	this.prev = () => {
		if(--__number < 0) {
			__number = banners.length - 1;
		}
		setBanner();
		return this;
	};

	this.count = () => banners.length;

	$app.on('start', () => {
		if(this.isEnabled()) {
			$('body').addClass('banner-enabled');
			setBanner();
		}
	});
};
